import HashtagFollowButton from "./hashtag-follow-button";

export default HashtagFollowButton;